import { homeMenu } from './home';
import { MenuItem } from '../../../commons/ui/menu';

export const routes: MenuItem[] = [
  homeMenu,
];
